<div class="is-flex flex-column">
    <span class="title-l ttu text-center mb-8"> {{ 'dev.myAccount.orders.dialogCancelTitle' | translate }}</span>
    <span class="text-l text-center mb-16" *ngIf="!isSubOrder">{{ orderId }}</span>
    <span class="text-l text-center"> {{ 'dev.myAccount.orders.dialogCancelText' | translate }}</span>
</div>
